/**
 * TanStack Query hooks for `data-residency`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dataResidencyQueryKeys,
	type CreateDataResidencyBody,
	type ListDataResidencyResponse,
	type DataResidencyRow,
} from "./api";

export function useDataResidencyList(): UseQueryResult<ListDataResidencyResponse, Error> {
	return useQuery({
		queryKey: dataResidencyQueryKeys.list(),
		queryFn: list,
	});
}

export function useDataResidencyCreate(): UseMutationResult<DataResidencyRow, Error, CreateDataResidencyBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dataResidencyQueryKeys.all });
		},
	});
}

export function useDataResidencyDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dataResidencyQueryKeys.all });
		},
	});
}
